const RESIZE_OBSERVER_LOOP_FRAGMENTS = [
  'ResizeObserver loop completed with undelivered notifications',
  'ResizeObserver loop limit exceeded',
]

let isInstalled = false
let patchIntervalId = null
let patchTimeoutId = null

export const isResizeObserverLoopError = (message = '') =>
  RESIZE_OBSERVER_LOOP_FRAGMENTS.some((fragment) => message.includes(fragment))

const patchReactErrorOverlay = () => {
  const hook = window.__REACT_ERROR_OVERLAY_GLOBAL_HOOK__
  if (!hook || hook.__resizeObserverLoopPatched) {
    return
  }

  const originalHandleError = hook.handleError

  hook.handleError = (error) => {
    const message = error?.message || String(error || '')

    if (isResizeObserverLoopError(message)) {
      return
    }

    if (typeof originalHandleError === 'function') {
      originalHandleError(error)
    }
  }

  hook.__resizeObserverLoopPatched = true
}

export const installResizeObserverLoopErrorSuppressor = () => {
  if (isInstalled || typeof window === 'undefined') {
    return () => {}
  }

  isInstalled = true

  const onWindowError = (event) => {
    const message = event.message || event.error?.message || ''

    if (!isResizeObserverLoopError(message)) {
      return
    }

    event.stopImmediatePropagation()
    event.preventDefault()
  }

  window.addEventListener('error', onWindowError, true)
  patchReactErrorOverlay()

  patchIntervalId = window.setInterval(patchReactErrorOverlay, 250)
  patchTimeoutId = window.setTimeout(() => {
    window.clearInterval(patchIntervalId)
    patchIntervalId = null
  }, 10000)

  return () => {
    window.removeEventListener('error', onWindowError, true)

    if (patchIntervalId) {
      window.clearInterval(patchIntervalId)
      patchIntervalId = null
    }

    if (patchTimeoutId) {
      window.clearTimeout(patchTimeoutId)
      patchTimeoutId = null
    }

    isInstalled = false
  }
}
